import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const {FiMail, FiPhone, FiMapPin} = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-luxe-black text-white" role="contentinfo">
      <div className="h-1 bg-gradient-to-r from-gold-500 via-luxe-red to-gold-500"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Info */}
          <div className="space-y-6">
            <Logo className="text-2xl" />
            <p className="text-gray-400 leading-relaxed">
              Queens' premier auto repair shop specializing in luxury and electric vehicles. Tesla-certified excellence.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-gray-300">
                <SafeIcon icon={FiMapPin} className="text-gold-500" />
                <span className="text-sm">233-20 Northern Blvd, NY 11362</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <SafeIcon icon={FiPhone} className="text-gold-500" />
                <a href="tel:+17182298400" className="text-sm hover:text-gold-500">+1 (718) 229-8400</a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gold-500">Navigation</h3>
            <ul className="space-y-3">
              {['Home', 'Services', 'Tesla Repair', 'About', 'Contact'].map((item) => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase().replace(' ', '-') === 'home' ? '' : item.toLowerCase().replace(' ', '-')}`} className="text-gray-400 hover:text-gold-500 transition-colors flex items-center gap-2">
                    <span className="text-xs text-gold-500">›</span> {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gold-500">Business Hours</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex justify-between"><span>Mon - Fri:</span> <span>8:00 AM - 6:00 PM</span></li>
              <li className="flex justify-between"><span>Saturday:</span> <span>8:00 AM - 5:00 PM</span></li>
              <li className="flex justify-between text-gold-500/60"><span>Sunday:</span> <span>Closed</span></li>
            </ul>
          </div>

          {/* Legal & Sitemap */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-gold-500">Resources</h3>
            <ul className="space-y-3">
              <li>
                <a href="/sitemap.xml" target="_blank" className="text-gray-400 hover:text-gold-500 transition-colors flex items-center gap-2">
                  <span className="text-xs text-gold-500">›</span> Sitemap (XML)
                </a>
              </li>
              {['Privacy Policy', 'Terms of Service', 'Accessibility'].map((item) => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase().replace(/ /g, '-')}`} className="text-gray-400 hover:text-gold-500 transition-colors flex items-center gap-2">
                    <span className="text-xs text-gold-500">›</span> {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      
      <div className="bg-luxe-darkgray py-6 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2026 Douglaston Auto Care. All Rights Reserved.</p>
          <p className="text-gray-500 text-sm">Powered by <a href="https://mobilefirstpro.com" className="text-gold-500 hover:underline">Mobile First Pro</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;